__turbopack_context__.v({
  "carouselContainer": "GuidesCarousel-module-scss-module__wMXzEG__carouselContainer",
  "carouselSubtitle": "GuidesCarousel-module-scss-module__wMXzEG__carouselSubtitle",
  "carouselTitle": "GuidesCarousel-module-scss-module__wMXzEG__carouselTitle",
  "header": "GuidesCarousel-module-scss-module__wMXzEG__header",
  "item": "GuidesCarousel-module-scss-module__wMXzEG__item",
  "loadingContainer": "GuidesCarousel-module-scss-module__wMXzEG__loadingContainer",
  "loadingResponsiveWrapper": "GuidesCarousel-module-scss-module__wMXzEG__loadingResponsiveWrapper",
  "root": "GuidesCarousel-module-scss-module__wMXzEG__root",
});
